<template>
  <div v-if="conditions.length" class="ncrm-contacts-filter-bar">
    <span v-if="logic === 'or' && conditions.length > 1" class="ncrm-contacts-filter-bar__logic">
      {{ $t("ncrm.contacts.advancedFilter.logicOrBadge") }}
    </span>
    <button
      v-for="(condition, index) in conditions"
      :key="`contacts-filter-pill-${index}-${condition.field_key}`"
      type="button"
      class="ncrm-contacts-filter-bar__pill"
      @click="$emit('edit')"
    >
      <span class="ncrm-contacts-filter-bar__pill-text">{{ chipLabel(condition) }}</span>
      <span
        class="ncrm-contacts-filter-bar__pill-clear"
        role="button"
        :aria-label="$t('ncrm.contacts.advancedFilter.removeCondition')"
        @click.stop="$emit('remove', index)"
      >
        <v-icon size="14">mdi-close</v-icon>
      </span>
    </button>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon="mdi-filter-remove-outline"
          variant="text"
          color="primary"
          size="small"
          :aria-label="$t('ncrm.contacts.advancedFilter.clearAll')"
          @click="$emit('clear')"
        />
      </template>
      <span>{{ $t("ncrm.contacts.advancedFilter.clearAll") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import {
  buildContactsFilterChipLabel,
  normalizeContactsAdvancedFilters,
  CONTACTS_FILTER_OPERATOR_VALUES,
} from "@/Utile/ncrmContactsAdvancedFilter.mjs";

export default {
  name: "NcrmContactsFilterBar",
  props: {
    modelValue: {
      type: Object,
      default: () => ({ logic: "and", conditions: [] }),
    },
  },
  emits: ["edit", "remove", "clear"],
  computed: {
    normalizedFilters() {
      return normalizeContactsAdvancedFilters(this.modelValue);
    },
    conditions() {
      return this.normalizedFilters.conditions;
    },
    logic() {
      return this.normalizedFilters.logic;
    },
    operatorLabels() {
      return Object.fromEntries(
        CONTACTS_FILTER_OPERATOR_VALUES.map((value) => [value, this.operatorLabel(value)])
      );
    },
  },
  methods: {
    operatorLabel(value) {
      const map = {
        equals: "ncrm.contacts.advancedFilter.operators.equals",
        not_equals: "ncrm.contacts.advancedFilter.operators.notEquals",
        contains: "ncrm.contacts.advancedFilter.operators.contains",
        not_contains: "ncrm.contacts.advancedFilter.operators.notContains",
        is_empty: "ncrm.contacts.advancedFilter.operators.isEmpty",
        is_not_empty: "ncrm.contacts.advancedFilter.operators.isNotEmpty",
      };
      return map[value] ? this.$t(map[value]) : value;
    },
    chipLabel(condition) {
      const displayed = condition?.field_key === "privacy_state"
        ? { ...condition, value: this.$t(`ncrm.contacts.dataProtection.states.${condition.value}`) }
        : condition;
      return buildContactsFilterChipLabel(displayed, { operatorLabels: this.operatorLabels });
    },
  },
};
</script>

<style scoped src="./NcrmContactsFilterBar.styles.css"></style>
